var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-2 text-center"},[_c('font-awesome-icon',{staticClass:"fa-2xl mb-2",attrs:{"icon":"spinner","spin":""}}),_c('h5',[_vm._v("LOADING....")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }